import { Component,EventEmitter,Input,OnChanges,OnInit,Output,SimpleChanges } from "@angular/core";
import { SampleHistoryProcessSteps } from "../models/sampleHistoryProcessSteps";
import { AnnouncedService } from "../apg-announced/services/announced.service";
import { MessagesNewService } from "../messages-new/messages.service";
import { AdminSearchService } from "../admin-search/admin-search/admin-search.service";
import { ALWAYS_VISIBLE_SAMPLE_KEYS,KEYS_TO_BE_SKIPPED_IN_SAMPLE_METADATA,convertUTCToLocal,prepareHistoryProcessSteps,DEFAULT_DATE,DATES_TO_FORMAT,ProcessStepsForExcelExport } from "../history/history-utils";

@Component({
  selector: "app-sample-search",
  templateUrl: "./sample-search.component.html",
  styleUrls: ["./sample-search.component.css"],
})
export class SampleSearchComponent implements OnInit, OnChanges {
  @Input()
  searchType!: string;
  @Input()
  searchTypeValue!: string;
  @Input()
  selectedLabID!: string;
  @Input()
  puid!:string;

  @Output()
  onDownloadExcelClick = new EventEmitter<ProcessStepsForExcelExport>();

  sample: any = null;
  sampleProcessSteps: SampleHistoryProcessSteps[] = [];
  isLoading: boolean = false;
  sampleComments: any[] = [];
  samplePlateComments: any[] = [];
  keyRenameMap: Map<string, string> = new Map();

  displaySampleComment: boolean = false;
  displayBatchComment: boolean = false;

  duplicateSampleFound:boolean = false;
  duplicateSamples: any[] = [];

  constructor(
    private messageService: MessagesNewService,
    private adminService: AdminSearchService,
    private announcedService: AnnouncedService
  ) {}

  ngOnInit(): void {
    this.keyRenameMap.set("boxReceptionTimeStamp", "receivedTimeStamp");
    this.keyRenameMap.set("position", "processPosition");
    this.keyRenameMap.set("sampleUpdatedDate", "readyForProcessing");
    this.keyRenameMap.set("selectedSampleType", "Assigned Sample Type");
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.searchType || !this.searchTypeValue) {
      this.resetSampleSearch();
      return;
    }
    if (this.searchTypeValue && changes.searchTypeValue) {
      this.searchSampleBasedOnCriteria(this.searchType, this.searchTypeValue);
    }
  }

  resetSampleSearch() {
    this.sample = null;
    this.sampleProcessSteps = [];
    this.duplicateSampleFound = false;
  }

  searchSampleBasedOnCriteria(type: string, value: string): void {
    this.isLoading = true;
    this.announcedService.getSelectedSampleFromDelivery(this.selectedLabID, value, type).subscribe({
        next: (result) => {
          this.isLoading = false;
          let samples = result.data;
          if (samples.length > 1) {
            this.duplicateSamples = samples;
            this.duplicateSampleFound = true;
          } else {
            let sample = samples[0];
            let sampleID = sample["_id"];
            this.fetchSampleFromHistory(sampleID);
          }
        },
        error: (_error) => {
          this.isLoading = false;
          this.messageService.addWarningMessage({
            severity: "warn",
            summary: "Failed to find the sample",
            detail: "Ensure that the sample was announced before searching...",
          });
          this.resetSampleSearch();
        },
      });
  }

  selectedSampleFromDuplicate(sampleID): void {
    this.duplicateSampleFound = false;
    this.fetchSampleFromHistory(sampleID);
  }

  fetchSampleFromHistory(sampleID: string): void {
    this.isLoading = true;
    this.adminService.getSampleHistory(this.selectedLabID, sampleID).subscribe({
      next: (result) => {
        this.isLoading = false;
        this.sample = result.data;
        this.sample.topBarcode = this.sample.barCode;
        this.sampleComments = this.sample.comments;
        this.samplePlateComments = this.sample.plateComments;
        this.sampleProcessSteps = prepareHistoryProcessSteps(
          this.sample.plateProcessSteps,
          true
        );
      },
      error: (_error) => {
        this.isLoading = false;
        this.messageService.addWarningMessage({
          severity: "warn",
          summary: "Failed to find the sample's history",
        });
      },
    });
  }

  checkIfValidState(fields: any): boolean {
    const { key, value } = fields;

    if (ALWAYS_VISIBLE_SAMPLE_KEYS.includes(key)) {
      return true;
    }

    if (value == null || value === "" || value === DEFAULT_DATE) {
      return false;
    }

    return !KEYS_TO_BE_SKIPPED_IN_SAMPLE_METADATA.includes(key);
}

  renameKeys(key) {
    return this.keyRenameMap.has(key) ? this.keyRenameMap.get(key) : key;
  }

  formatData(fields: any): any {
    return DATES_TO_FORMAT.includes(fields.key)
      ? convertUTCToLocal(fields.value)
      : fields.value;
  }

  emitDownloadEvent(): void {
    const processStepsForExcelExport: ProcessStepsForExcelExport = {
      name: this.sample[this.searchType],
      processSteps: this.sampleProcessSteps
    }
    this.onDownloadExcelClick.emit(processStepsForExcelExport);
  }

  showSampleComment(){
    this.displaySampleComment = true;
  }

  showBatchComment(){
    if(this.sample?.sourcePlateID == null){
      this.messageService.addWarningMessage({ 
        severity: 'error', 
        summary: 'Sample not placed on a plate yet', 
        detail: "Sample not placed on a plate yet" 
      })
      return;
    }
    this.displayBatchComment = true;
  }

  getCommentsDialogHeader(){
    return `${this.searchTypeValue} comments`;
  }
}
